<script lang="ts">
  export let defaultstyle, controlType, buttonStyle, showGuides;

  import { createEventDispatcher, onMount, tick } from 'svelte';
  import nipplejs from 'nipplejs';

  export let name: string;
  export let ct = controlType; //'dynamic';
  export let follow = controlType == 'dynamic' ? true : false; // Don't use follow
  console.log('> ' + controlType + ' & follow = ' + follow + ' & Style = ' + buttonStyle);

  const dispatch = createEventDispatcher();

  const mol = name === 'right' ? 'look' : 'move';

  onMount(async () => {
    try {
      await tick();
    } catch (error) {
      console.error('failed to process tick', error);
    }
    const options: nipplejs.JoystickManagerOptions = {
      zone: document.getElementById(`joystick-${name}`),
      // color: buttonStyle === 'mtn' ? '#ffc107' : 'rgba(255,255,255,0.35)',
      color: 'rgba(255,255,255,0.35)',
      fadeTime: 250,
      follow: false,
      size: 140,
      mode: `${ct}`,
      position: {left: '50%', top: '50%'},
      dataOnly: false,
      dynamicPage: true,
    };
    const manager = nipplejs.create(options);

    manager.on('move', (ev, data) => {
      // hide ui controller
      var elem = document.getElementById(`${name}_stick`);
      elem.style.opacity = '0.15';

      const dData = {
        event: mol,
        value: {
          x: data.vector.x * 100,
          y: data.vector.y * 100,
        },
      };
      dispatch('message', dData);
    });
    manager.on('end', (ev, data) => {
      // console.log('end event');
      // show ui controller
      var elem = document.getElementById(`${name}_stick`);
      elem.style.opacity = '1';

      const dData = {
        event: mol,
        value: {
          x: 0,
          y: 0,
        },
      };
      dispatch('message', dData);
    });

    /* This line was throwing an error for some reason so I commented it out and seemed to still work? */
    // joystick.ui
  });
</script>

<!-- <div class="wrapper {name}" id="joystick-{name}">
	<div class="front"></div>
	<div class="back"></div>
</div> -->

<div
  class="analog {defaultstyle ? 'shadow' : 'glass'} {showGuides
    ? 'guides'
    : ''} analog-{buttonStyle}"
  id="joystick-{name}"
>
  <div id="{name}_stick" class="stick shadow stick-{buttonStyle}">
    <div id="{name}_zone" class="label">{name == 'left' ? 'L' : 'R'}</div>
  </div>
</div>

<style>
  #joystick-left {
    /* test */
    touch-action: manipulation;
  }
  #joystick-right {
    touch-action: manipulation;
  }
  #left_zone, #right_zone {
    /* border:1px solid red; */
  }
  .guides {
    border: 1px dashed rgba(255, 255, 255, 0.5) !important;
    /* background-color: green !important; */
  }

  .analog,
  .stick,
  .label {
    transition: all 0.2s;
  }
  .label {
    font-size: 1.3rem;
    font-weight: 700;
    margin-top: 26%;
    color: rgba(0, 0, 0, 0.3);
  }

  /* Default theme */
  .analog-default {
    background-color: rgba(0, 0, 0, 0.1);
    border: 1.5px dashed rgba(255, 255, 255, 0.25);
    box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
  }
  .stick-default {
    background-color: rgba(0, 0, 0, 0.1);
    border: 1.5px solid rgba(255, 255, 255, 1);
    /* box-shadow: none !important; */
  }
  .stick-default div.label {
    color: rgba(255, 255, 255, 1);
  }

  /* Xbox Theme */
  .analog-colour {
    background-color: rgba(0, 0, 0, 0.25);
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.05) 20%,
      rgba(0, 0, 0, 0.2) 80%
    );
    box-shadow: none !important;
  }
  .stick-colour {
    background-color: rgba(0, 0, 0, 0.5);
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(25, 25, 25, 1) 40%,
      rgba(25, 25, 25, 1) 60%,
      rgba(60, 60, 60, 1) 100%
    );
  }
  .stick-colour div.label {
    color: rgba(0, 0, 0, 0);
    background: linear-gradient(
      0deg,
      rgba(150, 150, 150, 0.2) 0%,
      rgba(0, 0, 0, 0.5) 100%
    );
    border-radius: 500px;
    margin: 20% !important;
    border: 1.5px solid rgba(50, 50, 50, 1);
  }

  /* MTN Theme */
  .analog-mtn {
    background-color: rgba(0, 0, 0, 0.75);
    box-shadow: none !important;
  }
  .stick-mtn {
    background-color: #ffc107; /* MTN Yellow */
    box-shadow: none !important;
  }
  .stick-mtn div.label {
    color: rgba(0, 0, 0, 0);
  }
</style>
